import { createGlobalState } from "react-hooks-global-state";


const initialState = {
  emailIsWritten: false,
  email: '',
  currentId:'',
  doc: false
};


export const {
  useGlobalState,
  getGlobalState,
  setGlobalState,
} = createGlobalState(initialState);